export const buttonHeight = 70;
export const defaultMarginBottom = 20;
export const withIntercomHeight = 90;
export const withoutIntercomHeight = 20;
